import React from 'react';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FastField } from 'formik';
import { formLabel } from '~/utils/helpers';

function TextArea({ rows, name, sm, as, className }) {
    return (
        <FastField name={name}>
            {({ field, form, meta }) => {
                const isValid = !meta.error;
                const isInvalid = meta.touched && !isValid;
                field.value = field.value ?? ''; //set field value to epmty string ("") to avoid `Warning: `value` prop on `input` should not be null`.

                return (
                    <Form.Group
                        as={as}
                        sm={sm}
                        className={className}
                    >
                        <Form.Label>{formLabel(name)}</Form.Label>
                        <Form.Control
                            {...field}
                            as="textarea"
                            rows={rows}
                            isInvalid={isInvalid}
                            isValid={form.touched[field.name] && isValid}
                        />
                        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                    </Form.Group>
                );
            }}
        </FastField>
    );
}

export default TextArea;
TextArea.defaultProps = {
    className: '',
    as: Col,
    sm: 3,
};
TextArea.propTypes = {
    rows: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    as: PropTypes.elementType,
};
